"use client";

import { useEffect } from "react";
import { useForm } from "react-hook-form";

type Props = {
  children: (formProps: Record<any, any>) => any;
  onSubmit: (data: Record<string, unknown>) => void;
  userData: Record<any, any>;
  validateOnMount?: boolean;
};

export default function Form({
  children,
  onSubmit,
  userData,
  validateOnMount = false,
}: Props) {
  const { control, formState, handleSubmit, register, reset, watch, trigger } =
    useForm({
      defaultValues: userData,
    });

  useEffect(
    function logErrors() {
      if (Object.keys(formState.errors).length) {
        console.log("Attempted Next Page With Validation Errors", {
          fieldsWithErrors: Object.keys(formState.errors),
        });
      }
    },
    [formState],
  );

  // Force react-hook-form to start fresh when navigating to a new page
  useEffect(
    function () {
      reset(userData);
    },
    [reset, userData],
  );
  useEffect(() => {
    if (validateOnMount) {
      trigger();
    }
  }, [trigger, validateOnMount]);
  const formValues = watch();
  const errors = formState.errors;

  return (
    <form className="kup-form" onSubmit={handleSubmit(onSubmit)}>
      {children({ control, errors, formValues, register, trigger })}
    </form>
  );
}
